export default __webpack_public_path__ + "static/media/animals.3ff52b91.jpg";